"use client";

import { useEffect } from "react";
import { getCheckoutGeoPricingCountryCode } from "@/lib/checkout-geo-pricing/getCheckoutGeoPricingCountryCode";
import { useCurrency } from "@/contexts/UserPreferencesContext/hooks/useCurrency";
import { hasExplicitCurrencyChoice } from "./cookieUtils";
import { getCurrencyForCountry } from "./getCurrencyForCountry";

export type UseCountryAutoDetectionCurrencyParams = {
  countryAutoDetection?: boolean;
};

export const useCountryAutoDetectionCurrency = ({
  countryAutoDetection,
}: UseCountryAutoDetectionCurrencyParams) => {
  const { selectedCurrency, setCurrency } = useCurrency();

  useEffect(() => {
    if (!countryAutoDetection) return;
    if (hasExplicitCurrencyChoice()) return;

    const countryCode = getCheckoutGeoPricingCountryCode();
    if (!countryCode) return;

    const currency = getCurrencyForCountry(countryCode);
    if (currency === selectedCurrency) return;

    setCurrency(currency);
  }, [countryAutoDetection, selectedCurrency, setCurrency]);
};
